<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-07-23 
-->
<template>
  <div class="home-header" id="home-header">
    <div class="header-content">
      <div class="header-left">
        <div class="header-logo" @click="handleChangeRoute('index', 'logo')">
          <img :src="static_img_url+'pic/logo.png?v=' + $store.state.imgVersion" />
        </div>
        <!-- <div class="header-str">
          <p class="p1">{{'中国·苏州' | dealLanguage('SUZHOU·CHINA')}}</p>
          <p class="p2">{{activityDetail.startTime | time_moment('YYYY.M.D')}}-{{activityDetail.endTime | time_moment('YYYY.M.D')}}</p>
        </div> -->
      </div>
      <div class="header-right">
        <div :class="['nav-item']" @click="handleChangeLanguage" v-if="$route.name != 'newsDetail'">
          <span :class="[language == 'zh' && 'active']">中</span>
          <span>/</span>
          <span :class="[language == 'en' && 'active']">EN</span>
        </div>
        <div class="login-btn" v-if="!user_key" @click="handleChangeRoute('login', '登录')">
          <span>{{'登录' | dealLanguage('Sign In')}}</span>
        </div>
        <div class="login-btn on" v-else @click="handleChangeRoute('user', '个人中心')">
          <span>{{'用户中心' | dealLanguage('USER CENTER')}}</span>
        </div>
        <div class="menu-btn" @click="handleChangeRoute('menu', '目录')">
          <i class="iconfont">&#xe678;</i>
        </div>
      </div>
    </div>
    <template v-if="channelDiscountRate < 1 && $route.name == 'signUp'">
      <div class="hero-overlay" v-if="language == 'en'">Get {{channelDiscountRate | discountShow}} tickets exclusively.</div>
      <div class="hero-overlay" v-else>当前购票享受{{channelDiscountRate | discountShowZh}}优惠</div>
    </template>
    <template v-if="asgctDiscountRate < 1 && $route.name == 'asgct'">
      <div class="hero-overlay" v-if="language == 'en'">Get {{asgctDiscountRate | discountShow}} tickets exclusively.</div>
      <div class="hero-overlay" v-else>当前购票享受{{asgctDiscountRate | discountShowZh}}优惠</div>
    </template>
    <van-popup v-model="menuShow" position="right" :style="{ height: '100%', width: '50%' }">
      <div class="header-navigation">
        <van-collapse v-model="activeName" accordion @change="handleChangeVisible">
          <div :class="['nav-item']" @click="handleChangeRoute('index', '首页')">
            <span>{{'首页' | dealLanguage('Index')}}</span>
          </div>
          <van-collapse-item :title="'关于CSGCT' | dealLanguage('About CSGCT')" name="关于CSGCT">
            <div :class="['sec-nav-item']" v-for="item,index in navPosition([284, 285, 297])" :key="`about-${index}`" @click="goExhibitionDesc(item.id, item.pageName)">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</div>
          </van-collapse-item>
          <van-collapse-item :title="'大会会议' | dealLanguage('Annual Meeting')" name="大会会议">
            <div :class="['sec-nav-item']" @click="handleChangeRoute('theme', '会议日程')">{{'会议日程' | dealLanguage('Scientific Program')}}</div>
            <div :class="['sec-nav-item']" @click="handleChangeRoute('guests', '会议嘉宾')">{{'会议嘉宾' | dealLanguage('Featured Speakers')}}</div>
          </van-collapse-item>
          <van-collapse-item :title="'大会活动' | dealLanguage('Conference Activities')" name="大会活动">
            <div :class="['sec-nav-item']" v-for="item,index in navPosition([286, 287, 288])" :key="`activity1-${index}`" @click="goExhibitionDesc(item.id, item.pageName)">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</div>
            <!-- <div :class="['sec-nav-item']" @click="handleChangeRoute('innovationAwards', '创新之星奖项')">{{'创新之星奖项' | dealLanguage('CSGCT Innnovation Awards')}}</div> -->
            <div :class="['sec-nav-item']" v-for="item,index in navPosition([290])" :key="`activity2-${index}`" @click="goExhibitionDesc(item.id, item.pageName)">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</div>
          </van-collapse-item>
          <div :class="['nav-item']" v-for="item,index in navPosition([291])" :key="`single-${index}`" @click="goExhibitionDesc(item.id, item.pageName)">
            <span>{{item.pageTitle | dealLanguage(item.enPageTitle)}}</span>
          </div>
          <van-collapse-item :title="'注册参会' | dealLanguage('Registration')" name="注册参会">
            <div :class="['sec-nav-item']" @click="handleChangeRoute('signUp', '大会注册')">{{'大会注册' | dealLanguage('Register Now')}}</div>
            <div :class="['sec-nav-item']" v-for="item,index in navPosition([292])" :key="`signup-${index}`" @click="goExhibitionDesc(item.id, item.pageName)">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</div>
          </van-collapse-item>
          <van-collapse-item :title="'展览赞助' | dealLanguage('Sponsor & Exhibit')" name="展览赞助">
            <div :class="['sec-nav-item']" v-for="item,index in navPosition([293])" :key="`sponsor-${index}`" @click="goExhibitionDesc(item.id, item.pageName)">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</div>
            <div :class="['sec-nav-item']" @click="handleChangeRoute('compReg', '成为赞助商')">{{'成为赞助商' | dealLanguage('Become a Sponsor')}}</div>
          </van-collapse-item>
          <van-collapse-item :title="'日常活动' | dealLanguage('CSGCT Programs')" name="日常活动">
            <div :class="['sec-nav-item']" v-for="item,index in navPosition([294, 295, 296])" :key="`program-${index}`" @click="goExhibitionDesc(item.id, item.pageName)">{{item.pageTitle | dealLanguage(item.enPageTitle)}}</div>
          </van-collapse-item>
          <div :class="['nav-item']" @click="handleChangeRoute('newsList', '新闻资讯')">
            <span>{{'新闻动态' | dealLanguage('News')}}</span>
          </div>
          <!-- <div :class="['nav-item']" @click="handleChangeRoute('newsList2', 'China CGT 100 Pioneers')" v-if="language == 'en'">
            <span>China CGT 100 Pioneers</span>
          </div> -->
        </van-collapse>
      </div>
    </van-popup>

    <van-popup v-model="userShow" position="right" :style="{ height: '100%', width: '50%' }">
      <div class="header-navigation user-nav">
        <div :class="['nav-item']" @click="handleChangeRoute('userInfo', '个人信息')">
          <span>{{'个人信息' | dealLanguage('Personal center')}}</span>
        </div>
        <div :class="['nav-item']" @click="handleChangeRoute('myTickets', '我的门票')">
          <span>{{'我的门票' | dealLanguage('My Tickets')}}</span>
        </div>
        <div :class="['nav-item']" @click="handleChangeRoute('orderList', '订单和发票')">
          <span>{{'订单和发票' | dealLanguage('Orders and Invoices')}}</span>
        </div>
        <div :class="['nav-item']" @click="handleChangeRoute('contributionList', '已提交摘要')">
          <span>{{'已提交摘要' | dealLanguage('My Abstracts')}}</span>
        </div>
        <!-- <div :class="['nav-item']" @click="handleChangeRoute('companions', '同行人')">
          <span>{{'同行人' | dealLanguage('Companion')}}</span>
        </div> -->
      </div>
      <div class="quit-btn" @click="exitlogin">
        <van-button type="default">{{'退出登录' | dealLanguage('Log out')}}</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Aexitlogin } from '@/service/app'
import filter from 'js/filter'
export default {
  inject: ['login', 'reload', 'globalInsertRecords'],
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      menuShow: false,
      userShow: false,
      activeName: '',
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      contentNav: (state) => state.contentNav,
      activityDetail: (state) => state.activityDetail,
      language: (state) => state.language,
      channelDiscountRate: (state) => state.channelDiscountRate,
      asgctDiscountRate: (state) => state.asgctDiscountRate,
    }),
    navPosition() {
      return function(ids) {
        let arr = this.contentNav.filter((item) => ids.includes(item.id))
        return arr
      }
    },
  },
  methods: {
    handleChangeVisible(name) {
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: name,
      })
    },
    handleChangeRoute(name, pageName) {
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: pageName,
      })
      if (name == 'login') {
        this.login()
      } else if (name == 'menu') {
        this.menuShow = true
      } else if (name == 'user') {
        this.userShow = true
      } else if (name == 'toplist') {
        window.location.href = 'https://vb100.vbdata.cn/Index/list'
      } else if (name == 'newsList2') {
        this.userShow = false
        this.menuShow = false
        this.$router.push({ name: 'newsList', query: { type: 2 } })
      } else {
        this.userShow = false
        this.menuShow = false
        this.$router.push({ name })
      }
    },
    goExhibitionDesc(itemid, pageName) {
      this.userShow = false
      this.menuShow = false
      this.globalInsertRecords({
        contentId: itemid,
        contentType: 81,
        viewType: 1,
        keyword: pageName,
      })
      this.$router.push({ name: 'exhibitionDesc', params: { id: itemid } })
    },
    async exitlogin() {
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: '退出登录',
      })
      let res = await Aexitlogin()
      if (res.code == 0) {
        this.$store.commit('updateUserKey', '')
        this.$store.commit('updateUser', '')
        this.$store.commit('setUUserId', '')
        this.userShow = false
        this.$notify({
          type: 'success',
          message: this.language == 'zh' ? '退出登录成功！' : 'Log out successfully!',
        })
        this.$router.push({ name: 'index' })
        this.reload()
      } else {
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleChangeLanguage() {
      let newLanguage = this.language === 'zh' ? 'en' : 'zh'
      // this.$store.commit('setLanguage', newLanguage)
      // localStorage.setItem('vbefLanguage', newLanguage)

      let routerQuery = this.$route.query
      if (newLanguage == 'en') {
        delete routerQuery.language
      } else {
        routerQuery.language = newLanguage
      }
      this.$store.commit('updateUserKey', '')
      const { href } = this.$router.resolve({ path: this.$route.path, query: routerQuery })
      location.href = href

      // this.$router.resolve({ path: this.$route.path, query: routerQuery })
      // this.$nextTick(() => {
      //   this.reload()
      // })
    },
  },
}
</script>
<style lang='stylus' scoped>
.hero-overlay
  width 100%
  height 0.64rem
  background #FFF3F3
  font-weight 400
  font-size 0.28rem
  color #C8161D
  line-height 0.64rem
  text-align center
.header-content
  height 1.22rem
  padding 0 0.4rem
  margin 0 auto
  display flex
  align-items center
  justify-content space-between
  .header-left
    display flex
    align-items center
  .header-right
    display flex
    align-items center
  .header-logo
    font-size 0
    display flex
    align-items center
    img
      width auto
      height 0.8rem
      cursor pointer
  .header-str
    margin-left 0.12rem
    .p1
      font-size 0.22rem
      line-height 0.24rem
      color #C8161D
    .p2
      color #C8161D
      font-size 0.14rem
      line-height 0.2rem
  .login-btn
    font-size 0.28rem
    color #333333
    line-height 0.39rem
    margin-left 0.4rem
    &.on
      color #C8161D
  .nav-item
    font-size 0.28rem
    color #333333
    line-height 0.39rem
    .active
      color #C8161D
  .menu-btn
    margin-left 0.4rem
    .iconfont
      color #333333
      font-size 0.4rem
.header-navigation
  >>> .van-collapse-item__content
    padding 4px 16px
  .nav-item
    position relative
    width 100%
    padding 10px 16px
    overflow hidden
    color #323233
    font-size 14px
    line-height 24px
    background-color #fff
    &::after
      position absolute
      box-sizing border-box
      content ' '
      pointer-events none
      top 0
      right 16px
      left 16px
      border-top 1px solid #ebedf0
      -webkit-transform scaleY(0.5)
      transform scaleY(0.5)
    &+.van-collapse-item::after
      position absolute
      box-sizing border-box
      content ' '
      pointer-events none
      top 0
      right 16px
      left 16px
      border-top 1px solid #ebedf0
      -webkit-transform scaleY(0.5)
      transform scaleY(0.5)
    &:active
      background-color #f2f3f5
  .sec-nav-item
    color #323233
    font-size 14px
    line-height 24px
    padding 6px 10px
    &:active
      background-color #f2f3f5
.user-nav
  padding-bottom 1.5rem
.quit-btn
  position absolute
  bottom 0
  left 0
  right 0
  padding 0.2rem 16px 0.4rem
  .van-button--default
    border-color #F9F9F9
    background #F9F9F9
    border-radius 0.2rem
    color #999999
    font-size 0.28rem
    height 0.9rem
    width 100%
</style>
